"use client"

import * as React from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { cn } from "@/utils"
import { buttonVariants } from "@/components/ui/button"

export interface CalendarProps {
  mode?: "single"
  selected?: Date
  onSelect?: (date: Date | null) => void
  disabled?: (date: Date) => boolean
  className?: string
  showOutsideDays?: boolean
  fromDate?: Date
  toDate?: Date
}

function Calendar({
  mode = "single",
  selected,
  onSelect,
  disabled,
  className,
  showOutsideDays,
  fromDate,
  toDate
}: CalendarProps) {
  return (
    <DatePicker
      selected={selected}
      onChange={(date) => onSelect?.(date as Date)}
      disabled={disabled}
      minDate={fromDate}
      maxDate={toDate}
      inline
      showPopperArrow={false}
      calendarClassName={cn(
        "p-3 bg-white dark:bg-slate-950 border rounded-lg shadow-lg",
        className
      )}
      dayClassName={(date) =>
        cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100 rounded-full",
          date?.toDateString() === selected?.toDateString() && "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
          date?.toDateString() === new Date().toDateString() && "bg-accent text-accent-foreground"
        )
      }
    />
  )
}

Calendar.displayName = "Calendar"

export { Calendar }